<teleport to="body">
  <transition name="fc-backdrop">
    <div
      v-if="is_open"
      class="floating-backdrop"
      aria-hidden="true"
      @click="collapse_modal"
    ></div>
  </transition>
  <div class="modal fade" id="view_job_profile_modal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
      <div class="modal-content bg-white rounded-3 p-0 shadow-lg border-0">
        
        <!-- Modal Header -->
        <div class="modal-header border-bottom-0 cute-header shadow-lg">
          <p class="modal-title text-white text-xxs">Job Description Editor</p>
          <button type="button" class="modal-btn-close btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>

        <!-- Modal Body -->
        <div class="modal-body p-3">
          <!-- Toolbar -->
          <div class="bg-light rounded-3 p-3 mb-3 shadow-sm">
            <div class="d-flex flex-wrap align-items-center justify-content-between gap-2">
              <div class="d-flex align-items-center gap-2">
                <div>
                  <small class="text-muted d-block mb-1 text-uppercase fw-600 text-xxs">Progress</small>
                  <div class="progress progress-compact w-100">
                    <div
                      class="progress-bar bg-primary"
                      :class="progress_width_class"
                      role="progressbar"
                      :aria-valuenow="parsed_completion_percent"
                      aria-valuemin="0"
                      aria-valuemax="100"
                    ></div>
                  </div>
                  <small class="text-muted mt-1 d-block text-xxs">{{ parsed_completion_percent }}% Complete</small>
                </div>
              </div>

              <div class="d-flex gap-2 flex-wrap">
                <div class="btn-group btn-group-sm" role="group">
                  <button 
                    type="button" 
                    class="btn btn-sm text-xxs"
                    :class="parsed_editor_mode === 'preview' ? 'btn-primary-dark' : 'btn-outline-secondary'"
                    @click="$emit('update:mode', 'preview')"
                  >
                    <i class="bi bi-eye me-1"></i> Preview
                  </button>
                  <button 
                    type="button" 
                    class="btn btn-sm text-xxs"
                    :class="parsed_editor_mode === 'edit' ? 'btn-primary-dark' : 'btn-outline-secondary'"
                    @click="$emit('update:mode', 'edit')"
                  >
                    <i class="bi bi-pencil me-1"></i> Edit
                  </button>
                  <button 
                    type="button" 
                    class="btn btn-sm text-xxs"
                    :class="parsed_editor_mode === 'split' ? 'btn-primary-dark' : 'btn-outline-secondary'"
                    @click="$emit('update:mode', 'split')"
                  >
                    <i class="bi bi-columns-gap me-1"></i> Split
                  </button>
                </div>

                <div class="btn-group btn-group-sm" role="group">
                  <button class="btn btn-outline-secondary btn-sm text-xxs" @click="$emit('undo')" :disabled="parsed_history_index <= 0" title="Undo">
                    <i class="bi bi-arrow-counterclockwise"></i>
                  </button>
                  <button class="btn btn-outline-secondary btn-sm text-xxs" @click="$emit('redo')" :disabled="parsed_history_index >= parsed_history.length - 1" title="Redo">
                    <i class="bi bi-arrow-clockwise"></i>
                  </button>
                </div>

                <div class="btn-group btn-group-sm" role="group">
                  <button class="btn btn-primary-dark btn-sm text-xxs shadow" @click="$emit('export-html')" title="Export HTML">
                    <i class="bi bi-file-earmark-text me-1"></i> HTML
                  </button>
                  <button class="btn btn-primary-dark btn-sm text-xxs shadow" @click="$emit('export-pdf')" title="Export PDF">
                    <i class="bi bi-file-earmark-pdf me-1"></i> PDF
                  </button>
                </div>

                <button class="btn btn-sm btn-primary-dark text-xxs px-3 shadow" @click="$emit('publish')" :disabled="!parsed_is_ready">
                  <i class="bi bi-check-circle me-1"></i> Publish
                </button>
              </div>
            </div>
          </div>

          <!-- Main Content Area -->
          <div class="row g-3">
            <!-- Navigation Sidebar -->
            <div class="col-12 col-lg-3">
              <div class="bg-light rounded-3 shadow-sm p-3">
                <h6 class="text-muted mb-3 text-uppercase fw-600 text-xxs">Sections</h6>
                <div class="list-group list-group-flush">
                  <button
                    v-for="section in parsed_sections"
                    :key="section.key"
                    type="button"
                    class="list-group-item list-group-item-action text-start border-0 rounded-3 mb-2 text-xxs"
                    :class="{ active: parsed_active_section === section.key }"
                    @click="$emit('update:section', section.key)"
                  >
                    <div class="d-flex justify-content-between align-items-start">
                      <div class="flex-grow-1">
                        <div class="d-flex align-items-center gap-2">
                          <strong class="text-xxs">{{ section.label }}</strong>
                        </div>
                        <small class="text-muted d-block text-xxs" v-if="section.required">Required</small>
                      </div>
                      <div class="d-flex gap-1 align-items-center">
                        <span v-if="section_has_content(section.key)" class="badge bg-success rounded-pill text-xxs">
                          <i class="bi bi-check-lg"></i>
                        </span>
                        <span v-if="!section.required" class="badge bg-light text-muted rounded-pill text-xxs">Optional</span>
                      </div>
                    </div>
                  </button>
                </div>
              </div>
            </div>

            <!-- Content Area -->
            <div class="col-12 col-lg-9">
              <!-- Preview Mode -->
              <div v-if="should_show_parsed_preview" ref="parsedPreview" class="card border-0 shadow-sm rounded-3">
                <div class="card-body p-3">
                  <job-preview-content 
                    :parsed_document="parsed_document" 
                    :parsed_active_section="parsed_active_section"
                    :raw_text="parsed_raw_text"
                  />
                </div>
              </div>

              <!-- Edit Mode -->
              <div v-if="should_show_parsed_editor" class="card border-0 shadow-sm rounded-3">
                <div class="card-body p-3">
                  <job-editor-content
                    :parsed_document="parsed_document"
                    :parsed_active_section="parsed_active_section"
                    :parsed_responsibility_index="parsed_responsibility_index"
                    @update="$emit('update:document', $event)"
                  />
                </div>
              </div>

              <!-- Save Status Message -->
              <div v-if="parsed_save_message" class="alert rounded-3 border-0 mt-2 text-xxs" :class="{ 'alert-info': parsed_save_state === 'saving', 'alert-success': parsed_save_state === 'saved', 'alert-danger': parsed_save_state === 'error' }">
                <i class="bi me-2" :class="{ 'bi-hourglass-split': parsed_save_state === 'saving', 'bi-check-circle-fill': parsed_save_state === 'saved', 'bi-exclamation-triangle-fill': parsed_save_state === 'error' }"></i>
                {{ parsed_save_message }}
              </div>
            </div>
          </div>
        </div>

        <!-- Modal Footer -->
        <div class="modal-footer border-0 p-2 d-flex justify-content-end">
          <button type="button" class="btn btn-primary-dark btn-sm px-3 shadow text-xxs me-2" data-bs-dismiss="modal">
            Close
          </button>
          <button type="button" class="btn btn-primary-dark btn-sm px-3 shadow text-xxs" @click="$emit('save')">
            Save Changes
          </button>
        </div>
      </div>
    </div>
  </div>
</teleport>
